import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/core/controls/base.component';
import { SocialMedia } from 'src/models/socialmedia.model';
import { RestApiService } from 'src/services/rest-api.service';

@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.scss']
})
export class SocialComponent extends BaseComponent implements OnInit {

  ngUnsubscribe = new Subject<void>();
  social: SocialMedia;

  constructor(protected api: RestApiService<any>) {  super(); }

  ngOnInit(): void {
    this.social = new SocialMedia();
    this.getSocialMedia();
  }

  save() {
    this.api.postEntity<SocialMedia>(this.social, 'SocialMedia')
    .pipe(takeUntil(this.ngUnsubscribe)).subscribe( data => {
      if(data) this.toast("✓ شبکه های اجتماعی ذخیره شد");
    })
  }

  getSocialMedia() {
    this.api.getEntity<SocialMedia>('GetSocialMedia')
    .pipe(takeUntil(this.ngUnsubscribe)).subscribe( data => {
      if(data)
      this.social = data[0];
      console.log(data);
    });
  }
}
